// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"Team_layoutWrapper__X6S3o"};